import { render, staticRenderFns } from "./tradelist.vue?vue&type=template&id=71dc2268&scoped=true&"
import script from "./tradelist.vue?vue&type=script&lang=js&"
export * from "./tradelist.vue?vue&type=script&lang=js&"
import style0 from "./tradelist.vue?vue&type=style&index=0&id=71dc2268&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc2268",
  null
  
)

export default component.exports